import React from 'react';
import { DividedTabSection } from '../TabSections';
import { SECTIONS } from '../constants';

const { DESCRIPTION, TITLE } = SECTIONS.COST_COVERED;

const CostsCovered = () => {
  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      {/* TODO - remove TITLE placeholder with section content */}
      <div>{TITLE}</div>
    </DividedTabSection>
  );
};

export default CostsCovered;
